
import MyInputEcom from '~/components/ui/MyInputEcom.vue';
export default {
    name: 'CustomForm',
    components: {
        MyInputEcom,
    },
    props: {
        formId: {
            type: [String, Number],
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        backgroundImage: {
            type: String,
            default: '',
        },
        submitButtonText: {
            type: String,
            default: 'Отправить',
        },
        fields: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    data() {
        return {
            formData: {},
            formSubmitted: false,
        };
    },
    computed: {
        containerStyle() {
            if (this.backgroundImage) {
                return {
                    'background-image': `url(${this.backgroundImage})`,
                };
            }
            return {};
        },
    },
    created() {
        console.log(this.fields);
        this.fields.forEach(field => {
            this.$set(this.formData, field.name, field.field_type === 'checkbox' ? false : '');
        });
    },
    methods: {
        isFieldInvalid(field) {
            if (!field.required) return false;
            if (!this.formSubmitted) return false;
            const value = this.formData[field.name];
            if (field.field_type === 'checkbox') {
                return value !== true;
            }
            return !value || (typeof value === 'string' && value.trim() === '');
        },
        resetForm() {
            this.formData = {};
        },
        generateFieldType(type) {
            switch (type) {
                case 'text':
                    return 'text';
                case 'number':
                    return 'number';
                case 'tel':
                    return 'tel';
                case 'email':
                    return 'email';
                case 'textarea':
                    return 'textarea';
                default:
                    return 'text';
            }
        },
        async handleSubmit() {
            this.formSubmitted = true;
            // validate required fields
            const invalid = this.fields.find(f => this.isFieldInvalid(f));
            if (invalid) {
                // show toast or simply stop submission
                this.$buefy.toast.open({
                    duration: 5000,
                    message: this.$t('required'),
                    type: 'is-danger',
                    position: 'is-bottom-right',
                });
                return;
            }
            try {
                await this.$api.home.postLeaveRequest({
                    ...{
                        form_type: 'custom_form',
                        username: 'user',
                        phone: 'default_phone',
                    },
                    ...this.formData,
                    additional_info: {
                        ...this.formData,
                    },
                });

                this.$buefy.toast.open({
                    duration: 10000,
                    message: this.$t('success'),
                    type: 'is-success',
                    position: 'is-bottom-right',
                });
                this.formSubmitted = false;
                this.resetForm();
                this.$emit('closeModal');
            } catch (error) {
                this.$buefy.toast.open({
                    duration: 10000,
                    message: this.$t('error'),
                    type: 'is-danger',
                    position: 'is-bottom-right',
                });
            }
        },
    },
};
